import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;

const CustomerAcceptance = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Принятие заказчиком:">
      {getFieldDecorator('customerAcceptance')(
        <Select
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите варианты"
          allowClear={true}
          maxTagCount={0}
        >
          <Option key={1}>API не подключено</Option>
        </Select>
      )}
    </Form.Item>
  );
};

export default CustomerAcceptance;
